import React, { useState } from "react";
import Header from "./pages/header/header";
import Sidebar from "./pages/sidebar/sidebar";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={`main-container ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <Header onMenuToggle={handleMenuToggle} />

      {/* Overlay for mobile when sidebar open */}
      {/* {isSidebarOpen && <div className="overlay" onClick={handleCloseSidebar}></div>} */}

      <section className="main-content">
        <div className="dash-content position-relative">
          <Sidebar isOpen={isSidebarOpen} />
          {children}
        </div>
      </section>
    </div>
  );
};

export default Layout;
